export default __webpack_public_path__ + "static/media/rarity.bc9b2ce6.jpg";